<template>
    <ul v-if="chips && chips.length" class="chip-list">
        <li v-for="(chip, i) in visibleChips" :key="i" class="chip" :class="`chip--${chip.type}`">{{ chip.label }}</li>
        <li v-if="hiddenCount > 0">
            <button type="button" class="chip chip--toggle" :aria-expanded="String(expanded)" @click="expanded = !expanded">
                {{ expanded ? $i18n.gt('CHIP_LIST_LESS') : $i18n.gt('CHIP_LIST_MORE').replace('{count}', hiddenCount) }}
            </button>
        </li>
    </ul>
</template>

<script>
// Renders a list of small colored labels. Each chip is {type, label}, where type is one of
// 'pest', 'beneficial', 'pesticide' or 'invalid' (used for the color).
// Only the first `limit` chips are shown; a toggle chip reveals the rest.
export default {
    name: 'ChipList',
    props: {
        chips: Array,
        limit: {type: Number, default: 3},
    },
    data() {
        return {expanded: false}
    },
    computed: {
        hiddenCount() {
            return Math.max(0, (this.chips || []).length - this.limit)
        },
        visibleChips() {
            const chips = this.chips || []
            return this.expanded ? chips : chips.slice(0, this.limit)
        },
    },
}
</script>

<style lang="scss">
.chip-list {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin: 0;
    padding: 0;
    list-style: none;
}

.chip {
    display: inline-block;
    padding: 2px 10px;
    border: 1px solid transparent;
    border-radius: 999px;
    font-size: 0.85rem;
    line-height: 1.5;

    // text/background pairs all have at least 4.5:1 contrast
    &--pest, &--invalid {
        background-color: #FBE4E4;
        border-color: #F0B3B3;
        color: #8A2A2A;
    }
    &--beneficial {
        background-color: #DDF3DA;
        border-color: #A6DBA0;
        color: #1E5B2B;
    }
    &--toggle {
        background-color: #fff;
        border-color: #CCD4DE;
        color: #333;
        cursor: pointer;

        &:hover {
            background-color: #F3F7F2;
        }
    }
    &--pesticide {
        background-color: #E9EDF2;
        border-color: #CCD4DE;
        color: #333;
    }
}
</style>
